import { useState } from "react";
import { ChevronRight, ChevronLeft, CalendarDays } from "lucide-react";
import MondayReport from "../components/MondayReport";

const REPORTS = [
  {
    id: "monday",
    name: "Monday",
    blurb: "Revenue by store and units by category, for the last 3 completed weeks.",
    Component: MondayReport,
  },
];

export default function Reports() {
  const [openId, setOpenId] = useState(null);
  const active = REPORTS.find((r) => r.id === openId);

  return (
    <div className="space-y-6" data-testid="reports-page">
      <section className="flex items-baseline justify-between gap-6 flex-wrap">
        <div>
          <div className="bm-eyebrow text-neutral-500 mb-1">Toronto · Trends Desk</div>
          <h1 className="bm-headline text-4xl">Reports</h1>
        </div>
      </section>

      {!active && (
        <div className="border-2 border-[#0a0a0a] bg-[#faf8f2] divide-y divide-[#0a0a0a]/15" data-testid="report-list">
          {REPORTS.map((r) => (
            <button
              key={r.id}
              onClick={() => setOpenId(r.id)}
              data-testid={`report-item-${r.id}`}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-[#0a0a0a]/5"
            >
              <span className="flex items-start gap-3 min-w-0">
                <CalendarDays size={18} className="text-[#c72c2c] shrink-0 mt-0.5" />
                <span className="min-w-0">
                  <span className="block bm-headline text-lg">{r.name}</span>
                  <span className="block bm-eyebrow text-neutral-500 normal-case tracking-normal mt-0.5">{r.blurb}</span>
                </span>
              </span>
              <ChevronRight size={18} className="text-neutral-400 shrink-0" />
            </button>
          ))}
        </div>
      )}

      {active && (
        <div className="space-y-5">
          <button
            onClick={() => setOpenId(null)}
            data-testid="report-back-button"
            className="bm-eyebrow flex items-center gap-1 hover:text-[#c72c2c]"
          >
            <ChevronLeft size={14} /> All reports
          </button>
          <div>
            <h2 className="bm-headline text-2xl mb-1">{active.name}</h2>
          </div>
          <active.Component />
        </div>
      )}
    </div>
  );
}
